import { merge } from 'lodash';
import { ToolbarType } from 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const mobileModalStyles = {
  overlay: {
    top: 0,
    left: "auto",
    right: 0,
    bottom: "auto",
    position: "absolute",
    width: "100%",
    height: "calc(100% + 5px)",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1e4
  },
  content: {
    position: "absolute",
    top: "50%",
    color: "var(--ricos-settings-text-color, #000)",
    transform: "translateY(-50%)",
    right: 0,
    left: 0,
    bottom: "auto",
    border: "none",
    backgroundColor: "white",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    padding: 0,
    width: "calc(100% - 20px)",
    margin: "0 10px",
    direction: "ltr",
    zIndex: 6
  }
};
const stickyButtomMobileStyles = {
  overlay: __spreadProps(__spreadValues({}, mobileModalStyles.overlay), { position: "fixed" }),
  content: {
    width: "100%",
    bottom: 0,
    height: "max-content",
    padding: 0,
    right: 0,
    left: 0,
    top: "unset",
    fontWeight: "unset"
  }
};
const mobileFullScreenOverrideStyles = {
  overlay: {
    top: 0,
    left: 0,
    right: "auto",
    bottom: "auto",
    height: "100vh",
    width: "100vw",
    margin: 0,
    zIndex: 5
  },
  content: {
    top: 0,
    left: 0,
    right: "auto",
    bottom: "auto",
    color: "var(--ricos-settings-text-color, #000)",
    backgroundColor: "#fff",
    height: "100vh",
    width: "100vw",
    margin: 0,
    transform: "none",
    direction: "ltr",
    zIndex: 6
  }
};
const desktopSideBarStyles = {
  overlay: {
    top: 0,
    left: "auto",
    right: 0,
    bottom: "auto",
    position: "fixed",
    width: "100%",
    height: "calc(100% + 85px)",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 5
  },
  content: {
    position: "fixed",
    top: 0,
    left: "auto",
    right: 0,
    bottom: "auto",
    border: "none",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    color: "var(--ricos-settings-text-color, #000)",
    padding: 0,
    height: "100%",
    width: "100%",
    maxWidth: "420px",
    direction: "ltr",
    zIndex: 6
  }
};
const desktopModalOverrideStyles = {
  overlay: {},
  content: {
    top: "calc(50%)",
    transform: "translateY(-50%)",
    left: 0,
    right: 0,
    height: "auto",
    marginLeft: "auto",
    marginRight: "auto",
    direction: "ltr"
  }
};
const inlineStyles = {
  overlay: {
    background: "transparent",
    pointerEvents: "none"
  },
  content: {
    pointerEvents: "initial"
  }
};
const getModalStyles = ({
  customStyles,
  fullScreen = true,
  inline = false,
  isMobile = false,
  stickyButtomMobile = false
} = {}) => {
  const overrideStyles = [];
  if (isMobile) {
    if (fullScreen) {
      overrideStyles.push(mobileFullScreenOverrideStyles);
    }
    if (customStyles) {
      overrideStyles.push(customStyles);
    }
    if (stickyButtomMobile) {
      return stickyButtomMobileStyles;
    }
    return merge({}, mobileModalStyles, ...overrideStyles);
  } else {
    if (!fullScreen) {
      overrideStyles.push(desktopModalOverrideStyles);
    }
    if (inline) {
      overrideStyles.push(inlineStyles);
    }
    if (customStyles) {
      overrideStyles.push(customStyles);
    }
    return merge({}, desktopSideBarStyles, ...overrideStyles);
  }
};
const getBottomToolbarModalStyles = (buttonRef, {
  customStyles,
  centered = false,
  fullScreen = true,
  inline = false,
  isMobile = false
}, toolbarName) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const modalStyles = getModalStyles({
    customStyles,
    fullScreen,
    inline,
    isMobile
  });
  const height = parseInt(
    ((_b = (_a = customStyles.content) == null ? void 0 : _a.minHeight) == null ? void 0 : _b.toString().slice(0, 3)) || ((_d = (_c = customStyles.content) == null ? void 0 : _c.height) == null ? void 0 : _d.toString().slice(0, 3)) || "0",
    10
  );
  const modalWidth = parseInt(((_f = (_e = customStyles.content) == null ? void 0 : _e.width) == null ? void 0 : _f.toString().slice(0, 3)) || "0", 10);
  const windowWidth = window && window.innerWidth;
  const windowHeight = window && window.innerHeight;
  const { top, left, right, width } = buttonRef.getBoundingClientRect();
  const modalOverflowFromRight = left + modalWidth > windowWidth;
  const modalOverflowBottom = top + height > windowHeight;
  const isAboveButton = top - height - 11 > 0;
  const isRtl = buttonRef.closest("[dir=rtl]") !== null;
  const contentStyles = {
    top: isAboveButton ? top - height - 11 : top + 30,
    margin: 0,
    position: "absolute"
  };
  if (toolbarName === ToolbarType.SIDE) {
    contentStyles.top = modalOverflowBottom ? top - (top + height - windowHeight + 95) : top - 15;
    contentStyles.right = modalOverflowFromRight ? 15 : window.innerWidth - right - 10;
    contentStyles.left = modalOverflowFromRight ? window.innerWidth - modalWidth - 15 : left + 35;
  } else if (toolbarName === ToolbarType.SHORTCUT) {
    contentStyles.top = top - height + 9;
    contentStyles.left = left - 114;
    contentStyles.right = 0;
  } else if (centered) {
    contentStyles.left = left + width / 2 - parseInt(((_h = (_g = modalStyles == null ? void 0 : modalStyles.content) == null ? void 0 : _g.width) == null ? void 0 : _h.toString()) || "0") / 2;
    contentStyles.margin = ((_i = modalStyles == null ? void 0 : modalStyles.content) == null ? void 0 : _i.margin) || contentStyles.margin;
  } else if (isRtl) {
    contentStyles.right = window.innerWidth - right - 10;
  } else {
    contentStyles.left = left - 15;
  }
  return __spreadProps(__spreadValues({}, modalStyles), {
    content: __spreadValues(__spreadValues({}, modalStyles.content), contentStyles)
  });
};

export { getBottomToolbarModalStyles, getModalStyles };
//# sourceMappingURL=getModalStyles.js.map
